import {fromJS} from "immutable";
import {createPointSource, createSource} from "../../utils/createSource";
import {IMapState} from "../types";
import {IFeature_Collection_CONO} from "../../types";

export function createLayerSource (
mapStyle: IMapState['mapStyle'],
layersByType: IMapState['layersByType'],
layerName: string,
layerType?:string) {
    const featureCollection: IFeature_Collection_CONO = layersByType[layerName] as any;
    if (featureCollection) {
        if (layerType === 'point') {
            mapStyle = mapStyle
                .setIn(['sources', layerName], fromJS(createPointSource(featureCollection)));
        } else {
            mapStyle = mapStyle
                .setIn(['sources', layerName], fromJS(createSource(featureCollection)));
        }
        // } else if (layerType === 'line') {
        //     mapStyle = mapStyle
        //         .setIn(['sources', layerName], fromJS(createSource(featureCollection)));
        // } else {
        //     mapStyle = mapStyle
        //         .setIn(['sources', layerName], fromJS(createSource(featureCollection)));
        // }
    }
    return mapStyle;
}